@if (control) {
  @if (!disabled && (options.length !== 1 || !selectFirstIfEmpty)) {
    <div class="text-container">
      <input #input (input)="textChange.next()" [ariaLabel]="label" [formControl]="control" type="text" [matAutocomplete]="panel" (focusout)="onblur.emit()" />
      <mat-autocomplete #panel="matAutocomplete" [displayWith]="displayLabel()" panelClass="template-search-panel" requireSelection>
        @for (option of filteredOptions | async; track $index) {
          <mat-option [value]="option.value">
            <span [innerHTML]="option.label | iconReplace"></span>
          </mat-option>
        }
        @for (group of filteredGroups | async; track $index) {
          <mat-optgroup [label]="group.group">
            @for (option of group.options; track $index) {
              <mat-option [value]="option.value">
                <span [innerHTML]="option.label | iconReplace"></span>
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-autocomplete>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
  } @else if (value) {
    <app-template-html [value]="getOption(value)?.label" [control]="control" />
  } @else {
    <span>-</span>
  }
}
